import { Component, OnInit, Input, Inject, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';

import { MatSnackBar } from '@angular/material/snack-bar';
import {
  AuthenticationService, ApplicationApiService, AnnotationApiService, BlobApiService
} from '../../data-services/index';

import {
  IApplication, IApplicationInput, IApprovalTaskItem, IAnnotation, IUser
} from '@ebb-v2/ebb-integration';

export class InspectionFile {
  fileId: string;
  fileName: string;
  fileStage?: number;
  fileType: string;
  file: any;
  payLoad?: string;
  payLoadName?: string;
  fileShow: boolean;
}

@Component({
    selector: 'ebb-portal-inspection',
    templateUrl: './inspection.component.html',
    styles: [],
    standalone: false
})
export class InspectionComponent implements OnInit {
  @Input('application') application: IApplication;

  public currentUser: IUser;
  public photosToShow: InspectionFile[] = [];
  public preRetrofitPhotosToShow: InspectionFile[] = [];
  public postRetrofitPhotosToShow: InspectionFile[] = [];
  public permitFilesToShow: InspectionFile[] = [];
  public waitForFilesToShow = 0;
  public waitForFilesToSort = false;
  public labelShowHidePhotos = 'SHOW PROJECT DOCUMENTATION';
  public showHidePhotos = false;
  public formSavingProgress = false;
  public formDownloadProgress = false;
  public completedInspectionForm = false;
  public completedInspectionFile = false;
  public submittedInspection = false;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly apiApplication: ApplicationApiService,
    private readonly router: Router,
    private readonly snackBar: MatSnackBar,
    private readonly apiblob: BlobApiService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;
    this.loadSubmittedFiles();
    this.submittedInspection =
      this.application.ebbInspectionStatus === 700000002 ? true : false;
  }

  public loadSubmittedFiles(): void {
    this.waitForFilesToShow = 0;
    this.application.approvalTasks.sort((a, b) =>
      a.stageCode > b.stageCode ? 1 : -1
    );
    this.application.approvalTasks.forEach(task => {
      if (
        parseInt(task.uiTabName, 10) === 700000001 ||
        parseInt(task.uiTabName, 10) === 700000002 ||
        parseInt(task.uiTabName, 10) === 700000003
      ) {
        task.approvalTaskItems.forEach(item => {
          this.getSubmittedPhoto(item, task.stageCode);
        });
      }
      if (parseInt(task.uiTabName, 10) === 700000000) {
        task.approvalTaskItems.forEach(item => {
          item.annotations.forEach(annotation => {
            this.getSubmittedFile(item,annotation.id,annotation.fileName, task.stageCode);
          });

        });
      }
    });
    this.waitForFilesToSort = true;
  }

  public getSubmittedPhoto(item: IApprovalTaskItem, stageCode: number): void {
    if (item.payload && item.payloadName && item.payload.length > 0) {
      this.waitForFilesToShow++;
      this.apiblob
        .getTaskFiles(item.payload, item.payloadName, 1)
        .subscribe(res => {
          this.createImageFromBlob(item, stageCode, res);
        });
    } else {
      this.createImage(item, stageCode);
    }
  }

  public getSubmittedFile(item: IApprovalTaskItem,fileid:string,filename:string, stageCode: number): void {
    if (item.id && item.id.length > 0) {
      const fileGet: InspectionFile = {
        fileId: fileid,
        fileName: item.name,
        fileStage: stageCode,
        fileType: item.typeCodeOptionSet,
        file: null,
        fileShow: false
      };

      if (fileid && fileid.length > 0) {
        fileGet.payLoad = fileid;
        fileGet.payLoadName = filename;
      }

      if (item.name !== 'Construction Time Span' && item.name !== 'Inspection') {
        this.permitFilesToShow.push(fileGet);
      }
    }
  }

  public createImage(item: IApprovalTaskItem, stageCode: number) {
    const fileGet: InspectionFile = {
      fileId: item.id,
      fileName: item.name,
      fileStage: stageCode,
      fileType: item.typeCodeOptionSet,
      file: null,
      fileShow: false
    };

    if (item.payload && item.payload.length > 0) {
      fileGet.payLoad = item.payload;
      fileGet.payLoadName = item.payloadName;
    }

    fileGet.fileShow = true;
    this.photosToShow.push(fileGet);
    if (stageCode === 700000000) {
      this.preRetrofitPhotosToShow.push(fileGet);
    } else {
      this.postRetrofitPhotosToShow.push(fileGet);
    }
    this.preRetrofitPhotosToShow.sort((a, b) =>
      a.fileType > b.fileType ? 1 : -1
    );
    this.postRetrofitPhotosToShow.sort((a, b) =>
      a.fileType > b.fileType ? 1 : -1
    );
    this.waitForFilesToShow--;
  }
  public createImageFromBlob(
    item: IApprovalTaskItem,
    stageCode: number,
    fileBlob: Blob
  ) {
    const reader = new FileReader();

    const fileGet: InspectionFile = {
      fileId: item.id,
      fileName: item.name,
      fileStage: stageCode,
      fileType: item.typeCodeOptionSet,
      file: null,
      fileShow: false
    };

    if (item.payload && item.payload.length > 0) {
      fileGet.payLoad = item.payload;
      fileGet.payLoadName = item.payloadName;
    }

    reader.addEventListener(
      'load',
      () => {
        fileGet.file = reader.result;
        fileGet.fileShow = true;
        this.photosToShow.push(fileGet);
        if (stageCode === 700000000) {
          this.preRetrofitPhotosToShow.push(fileGet);
        } else {
          this.postRetrofitPhotosToShow.push(fileGet);
        }
        this.preRetrofitPhotosToShow.sort((a, b) =>
          a.fileType > b.fileType ? 1 : -1
        );
        this.postRetrofitPhotosToShow.sort((a, b) =>
          a.fileType > b.fileType ? 1 : -1
        );
        this.waitForFilesToShow--;
      },
      false
    );

    reader.readAsDataURL(fileBlob);
  }

  public onViewPhotoEvent(photo: InspectionFile): void {
    if (!photo.payLoad && photo.payLoad.length === 0) {
      console.warn(`Cannot enlarge photo.`);
      return;
    }
    this.apiblob.getTaskFiles(photo.payLoad, photo.fileName, 1).subscribe(
      fileBlob => {
        let navigator : any = window.navigator;
        if (navigator && navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(fileBlob, photo.payLoadName);
        } else {
          const linkToView = this.document.createElement('a');
          linkToView.href = window.URL.createObjectURL(fileBlob);
          linkToView.target = '_blank';
          linkToView.id = photo.payLoadName;
          document.body.appendChild(linkToView);
          linkToView.click();
          linkToView.remove();
        }
      },
      error => {
        console.warn(error);
      }
    );
  }

  public lookupSubmittedPhoto(itemId): InspectionFile {
    const result = this.photosToShow.find(i => i.fileId === itemId);
    if (result) {
      return result;
    } else {
      const notFound: InspectionFile = {
        fileId: itemId,
        fileName: 'Not Found',
        fileType: 'Not Found',
        file: '../assets/images/imageNotFound.png',
        fileShow: true
      };
      return notFound;
    }
  }

  public onViewFileEvent(itemId: string): void {
    const file: InspectionFile = this.permitFilesToShow.filter(
      i => i.fileId === itemId
    )[0];

    if (!file.payLoad && file.payLoad.length === 0) {
      return;
    }
    this.saveAsSubmittedFile(file);
  }

  private saveAsSubmittedFile(file: InspectionFile): any {
    this.formDownloadProgress = true;
    if (file.payLoad && file.payLoad.length > 0) {
      this.apiblob.getTaskFiles(file.payLoad, file.payLoadName, 1).subscribe(
        fileBlob => {
          let navigator : any = window.navigator;
          this.formDownloadProgress = false;
          if (navigator && navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(fileBlob, file.payLoadName);
          } else {
            const downloadLink = this.document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(fileBlob);
            downloadLink.download = file.payLoadName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
          }
        },
        error => {
          console.warn(error);
        }
      );
    }
  }

  public toggleShowHidePhotos(): void {
    this.showHidePhotos = !this.showHidePhotos;
    this.showHidePhotos
      ? (this.labelShowHidePhotos = 'HIDE PROJECT DOCUMENTATION')
      : (this.labelShowHidePhotos = 'SHOW PROJECT DOCUMENTATION');
  }

  public onClickSubmitInspectionDocumentation(): void {
    const applicationInput: IApplicationInput = {} as IApplicationInput;
    this.formSavingProgress = true;
    applicationInput.ebbInspectionStatus = 700000002; // COMPLETED
    this.apiApplication
      .updateApplication(applicationInput, this.application.id)
      .subscribe(
        () => {
          this.formSavingProgress = false;
          this.snackBar.open('Your documentation has been submitted', '', {
            duration: 4000
          });
          this.router.navigate(['home']);
        },
        error => console.warn(`ERROR: onClickSaveInspectionInfo() - ${error}`)
      );
  }

  public onEmitInspectionFormChangeEvent(event: boolean): void {
    this.completedInspectionForm = event;
  }

  public onEmitInspectionFileChangeEvent(event: boolean): void {
    this.completedInspectionFile = event;
  }
}
